import Tile from '@/store/models/Tile'
import { Gender, SelectionTitleLists, SelectionType } from '@/data/enums'
import ProfileModel from '@/store/models/ProfileModel'

export interface ISelectionList<T> {
  [id: string]: T[]
}

export interface IClientProfile {
  age: number
  gender: number
  id?: string
  name: string
  selected: ISelectionList<number>
  values: ISelectionList<number>
  version: number
}

export default class ClientProfile implements IClientProfile {
  public age!: number
  public gender: number = 0
  public id?: string
  public name: string = ''
  public version: number = 2

  public selected: ISelectionList<number> = {
    [SelectionType.Activity]: [],
    [SelectionType.Gender]: [],
    [SelectionType.Glasses]: [],
    [SelectionType.Screen]: [],
    [SelectionType.Sport]: [],
    [SelectionType.Transport]: []
  }
  public values: ISelectionList<number> = {
    [SelectionType.Glasses]: [],
    [SelectionType.Screen]: [],
    [SelectionType.Transport]: []
  }

  constructor (
    name: string,
    clientProfile?: ClientProfile,
    profile?: ProfileModel
  ) {
    if (clientProfile) {
      Object.assign(this, {}, clientProfile)
    } else if (profile) {
      this.age = profile.getAge()
      this.gender = profile.getGender() === 'male' ? 0 : 1
      this.name = name
      const profileSelections = {
        [SelectionType.Activity]: profile.getItemList(SelectionType.Activity),
        [SelectionType.Gender]: profile.getItemList(SelectionType.Gender),
        [SelectionType.Glasses]: profile.getItemList(SelectionType.Glasses),
        [SelectionType.Screen]: profile.getItemList(SelectionType.Screen),
        [SelectionType.Sport]: profile.getItemList(SelectionType.Sport),
        [SelectionType.Transport]: profile.getItemList(SelectionType.Transport)
      }
      for (const [key, tileList] of Object.entries(profileSelections)) {
        tileList.forEach((tile: Tile, index: number) => {
          if (this.selected.hasOwnProperty(key)) {
            if (tile.selected) {
              this.selected[key].push(index)
            }
          }
          if (this.values.hasOwnProperty(key)) {
            if (tile.hasOwnProperty('value') && typeof tile.value === 'number') {
              this.values[key].push(tile.value)
            }
          }
        })
      }
    }
  }
}
